import "../css/FourColumnsRoundedImg.css";
import { Button, Flex, Row, Col } from 'antd';
import { useQuery } from "@apollo/client";
import { GET_FOUR_COLUMNS_ROUNDED_IMG_BY_SLUG } from "../queries";
import { useState } from "react";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import { ImageOverlay } from "./Cards";
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl"
import useIsMobile from "../utils/isMobile";

const parseData = (data) => {
  return Object.entries(data)
  .map(([key, image]) => { 
    if (image.imagen?.node?.mediaItemUrl)
      return {
        title: image.titulo || null,
        content: image.contenido || null,
        mediaItemUrl: image.imagen?.node?.mediaItemUrl,
      }
  });
}

const FourColumnsRoundedImg = ({ page, section, lang }) => {
  const isMobile = useIsMobile();
  const slug = `${page}-${section}-${lang}`;
  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });
  
  const { loading, error } = useQuery(GET_FOUR_COLUMNS_ROUNDED_IMG_BY_SLUG, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {            
      const postData = {
        titulo: fetchedData.sectionsBy?.fourcolumnsrounded?.tituloFcr,
        link: fetchedData.sectionsBy?.fourcolumnsrounded?.linkFc,
        images: parseData(fetchedData.sectionsBy?.fourcolumnsrounded.images)
      }  
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      }
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });

  return (
    <>
    {
      sectionData && (
        <Flex className="FourColumnsRounded">
          <Flex className="FourColumnsRoundedImg-title">
            <Flex>
              <h2
                className="h4-headline-500"
                dangerouslySetInnerHTML={{ __html: sectionData?.titulo }}
              />
            </Flex>
            {!isMobile && (
              <Button 
                className="bt-medium-500" 
                style={{color: '#0027F9' }} 
                type="link" 
                href={sectionData?.link?.url || '#'} 
                variant="link">
                  {sectionData?.link?.title || 'Get Started'}
              </Button>
            )}
          </Flex>
          <Row className="FourCard">
            {sectionData?.images.map((image, index) => ( 
              image && ( 
              <Col span={6} key={index}> 
                <ImageOverlay description={image.content} mediaItemUrl={setImageAbsoluteUrl(image.mediaItemUrl)} altText={image.title} /> 
              </Col>
              )
            ))}
          </Row>
        </Flex>
      )
    }
    </>
  );
};

export default FourColumnsRoundedImg;
